import ProductGrid from "@/components/ProductGrid";

export default function Candles() {
  return (
    <ProductGrid
      category="candles"
      eyebrow="Scented Candles"
      title="Relax. Unwind. Recharge."
      blurb="Premium hand-poured candle jars from 3.4 oz up to 12 oz. Soft fragrances chosen for quiet evenings."
    />
  );
}
